module.exports = __webpack_public_path__ + "img/logo-simjob.9fffd625.png";